import { Component, ElementRef } from '@angular/core';

const BUTTON_HOST_ATTRIBUTES = [
  'placeme-button',
  'placeme-stroked-button',
  'placeme-fat-button',
  'placeme-fab-button',
  'placeme-fab-stroked-button',
];
@Component({
  selector:
    // eslint-disable-next-line @angular-eslint/component-selector
    'button[placeme-button], a[placeme-button], button[placeme-stroked-button], button[placeme-fab-button], button[placeme-fab-stroked-button], a[placeme-stroked-button], button[placeme-fat-button], a[placeme-fat-button], a[placeme-fab-button], a[placeme-fab-stroked-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  constructor(private elementRef: ElementRef) {
    for (const attr of BUTTON_HOST_ATTRIBUTES) {
      if (this.hasHostAttributes(attr)) {
        this.getHostElement().classList.add(attr);
      }
    }
  }

  getHostElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  private hasHostAttributes(...attributes: string[]): boolean {
    return attributes.some(attribute => this.getHostElement().hasAttribute(attribute));
  }
}
